module.exports = __webpack_public_path__ + "static/img/pro_tit.4af18ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/pro_tit.png
// module id = 5yNS
// module chunks = 1